import React, { useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Draggable from "react-draggable";

import { GetLanguageString } from "../helper/Components";

const NonRafiqUserNameModal = ({ setModal, onSubmit, loading }) => {
  const [username, setUsername] = useState("");
  const [error, setError] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const toggle = () => {
    if (!loading) {
      setModal(false);
    }
  };

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    if (username.trim() === "") {
      setError(true);
      return;
    }

    onSubmit(username.trim());
  };

  return (
    <Draggable
      position={position}
      onDrag={handleDrag}
      handle=".modal-header"
      cancel=".no-drag, input, button"
    >
      <Modal isOpen={true} className="inmodal">
        <ModalHeader
          className="modal-title"
          tag="h4"
          style={{ cursor: "move" }}
        >
          {<GetLanguageString props="user_enter_username" />}
        </ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <FormGroup>
              <Label className="col-form-label">
                {<GetLanguageString props="user_user_name" />}
              </Label>
              <Input
                className="no-drag"
                type="text"
                name="username"
                value={username}
                disabled={loading}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setError(false);
                }}
                invalid={error}
                autoFocus
              />
              {error && (
                <h4 className="text-error">
                  {<GetLanguageString props="user_username_required" />}
                </h4>
              )}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="white" onClick={toggle} disabled={loading} type="button">
              {<GetLanguageString props="common_cancel" />}
            </Button>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {<GetLanguageString props="common_save_changes" />}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </Draggable>
  );
};

export default NonRafiqUserNameModal;
